import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { shouldForwardProp, shouldNotForwardProp } from '@ori/presentation-utils';
import { Chip, Fab, Tooltip as MuiTooltip, styled } from '@ori-ui/mui';
export var Deal = styled('div', {
  shouldForwardProp: shouldForwardProp()
})({
  zIndex: 1
});
export var CIRCLE_SIZE = 45;
var CIRCLE_SIZE_SMALL = 35;
var FONT_SIZE = 29;
var FONT_SIZE_SUPER_SMALL = 20;
var FONT_SIZE_OFFER_SMALL = 23;
export var Root = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var isOffer = _ref.isOffer,
    isSuper = _ref.isSuper,
    offerLabelSmallerOnMobile = _ref.offerLabelSmallerOnMobile,
    theme = _ref.theme;
  return _objectSpread(_objectSpread({
    alignItems: 'center',
    background: theme.palette.offer.main,
    borderRadius: '50%',
    color: theme.palette.common.white,
    display: 'flex',
    fontSize: theme.typography.pxToRem(FONT_SIZE),
    fontWeight: theme.typography.fontWeightBold,
    height: CIRCLE_SIZE,
    justifyContent: 'center',
    position: 'relative',
    width: CIRCLE_SIZE
  }, isSuper && offerLabelSmallerOnMobile && _defineProperty({}, theme.breakpoints.down('md'), {
    fontSize: theme.typography.pxToRem(FONT_SIZE_SUPER_SMALL),
    height: CIRCLE_SIZE_SMALL,
    width: CIRCLE_SIZE_SMALL
  })), isOffer && offerLabelSmallerOnMobile && _defineProperty({}, theme.breakpoints.down('md'), {
    fontSize: theme.typography.pxToRem(FONT_SIZE_OFFER_SMALL),
    height: CIRCLE_SIZE_SMALL,
    width: CIRCLE_SIZE_SMALL
  }));
});
export var Tooltip = styled(MuiTooltip)(function () {
  return {
    borderRadius: '100%',
    maxWidth: 300,
    textAlign: 'left',
    zIndex: 2
  };
});
export var TooltipFab = styled(Fab, {
  shouldForwardProp: shouldNotForwardProp(['offerLabelSmallerOnMobile'])
})(function (_ref4) {
  var offerLabelSmallerOnMobile = _ref4.offerLabelSmallerOnMobile,
    theme = _ref4.theme;
  return _objectSpread({
    boxShadow: 'none',
    height: 'inherit',
    minHeight: 'unset',
    width: 'inherit',
    svg: {
      fontSize: theme.typography.pxToRem(FONT_SIZE)
    }
  }, offerLabelSmallerOnMobile && _defineProperty({}, theme.breakpoints.down('md'), {
    svg: {
      fontSize: theme.typography.pxToRem(FONT_SIZE_OFFER_SMALL)
    }
  }));
});
export var CatalogueLink = styled('a', {
  shouldForwardProp: shouldForwardProp()
})(function () {
  return {
    textDecoration: 'underline'
  };
});
export var DealChip = styled(Chip)(function () {
  return {
    textTransform: 'uppercase'
  };
});
//# sourceMappingURL=styles.js.map